import React from 'react';
import { useRecordContext } from 'react-admin';
import UploadVideo from '../UploadVideo/UploadVideo';

const getUrlForDownload = (data) => {
  if (!data) {
    return '#';
  }
  if (data.muxHlsUrl) {
    return data.muxHlsUrl;
  }
  if (data.url) {
    return data.url;
  }
  if (data.rawFile) {
    return URL.createObjectURL(data.rawFile);
  }
  if (data.src) {
    return data.src;
  }
  return '#';
};

const getVideoName = (data) => {
  if (!data) {
    return 'No file selected';
  }
  if (data.originalName) {
    return data.originalName;
  }
  if (data.rawFile) {
    return data.rawFile.name;
  }
  if (data.title) {
    return data.title;
  }
  return 'unknown';
};

const FileFieldCustom = ({ checkedName, values, isSubtitle, checkedResource }) => {
  const record = useRecordContext();

  return (
    <>
      <a target="_blank" href={getUrlForDownload(record)} rel="noreferrer">
        {getVideoName(record)}
      </a>
      {isSubtitle && !record?.rawFile ? (
        <UploadVideo checkedResource={checkedResource} checkedName={checkedName} record={values} />
      ) : null}
    </>
  );
};

export default FileFieldCustom;
